<template>
    <div class="printContainerMulti transparent" style="position: relative">
        <div v-if="spiel">
            <div v-for="i in pages" :key="i">
                <wurfzettel :spiel="spiel" teamType="heim" :partie="i" :liga="liga"
                        class="wurfzettel first"></wurfzettel>
                <wurfzettel :spiel="spiel" teamType="gast" :partie="i" :liga="liga"
                            class="wurfzettel pageBreak"></wurfzettel>
            </div>
        </div>
        <!-- navigation box -->
        <div style="position: fixed; width: 26cm; top: 0; left: 0; height: 300px;
                        right: 0; margin: auto">
            <v-btn fab dark bottom right
                   color="primary" style="position: absolute; right: 90px; top: 15px; z-index: 15"
                   @click="openPrint()">
                <v-icon >mdi-printer</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
    import { db } from '../../../../services/db'
    import {Spiel} from "../../../../services/data/spiel";
    import Wurfzettel from "./spielBerichtPrint_Wurfzettel";
    export default {
        components: {Wurfzettel},
        name: "spiel-bericht-print-wurfzettel",
        data: () => ({
            spiel: null,
            landesverband: null,
        }),
        computed: {
            liga(){
                return this.spiel && this.landesverband ?
                    this.landesverband.ligen[this.spiel.getLigaId()].nameFull : '';
            },
            pages() {
                return this.spiel ? Object.keys(this.spiel.partien).length : 1;
            }
        },
        created(){
            this.setSpiel();
            //window.print();
        },
        methods: {
            setSpiel(){
                db.collection("spiele").doc(this.$route.query.id).get()
                    .then((doc) => {
                    if (doc.exists) {
                        console.log("Document data:", doc.data());
                        this.spiel = new Spiel();
                        this.spiel.setFromDataObject(doc.data());
                        this.setLandesverband();
                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                    }
                }).catch((error) => {
                    console.log("Error getting document:", error);
                });
            },
            setLandesverband(){
                db.collection("landesverbaende").doc(this.spiel.saison.lvId).get()
                    .then((doc) => {
                        if (doc.exists) {
                            console.log("Document data:", doc.data());
                            this.landesverband = doc.data();
                        } else {
                            // doc.data() will be undefined in this case
                            console.log("No such document!");
                        }
                    }).catch((error) => {
                    console.log("Error getting document:", error);
                });
            },
            openPrint(){
                window.print()
            }
        },
    }
</script>

<style scoped>
    @media print{@page {size: portrait; margin: 0}}
    /*https://codepen.io/rafaelcastrocouto/pen/LFAes*/
    .wurfzettel {
        height: 13.3cm; width: 17cm; margin: auto;
        border: solid 1px black;
    }
    .first {
        margin-top: 1.2cm;
    }
    .pageBreak {
        page-break-after: always;
        margin-top: 0.5cm
    }
    .printContainerMulti { position: relative; width: 100%;
        z-index: 20; overflow: auto;
        font-family: verdana, arial, helvetica;}
</style>